import io from "socket.io-client"
import * as API from "common/api"

export const socket = io(API.API_URL, { path: "/socket.io" })
